import { create } from "zustand"

import type { DimensionProps } from "../hooks/useInitDimensions"
import { RefObject } from "react"

interface State {
  dimension: DimensionProps
  isRedirected: boolean
  isDark: boolean
  topSafeArea: number
  bottomSafeArea: number
  pairsPosition: DOMRect[]
  navbarReference: RefObject<HTMLDivElement> | undefined
}

interface Actions {
  updateDimension: (dimension: State["dimension"]) => void
  updateIsDark: (isDark: State["isDark"]) => void
  setIsRedirected: (isRedirected: State["isRedirected"]) => void
  updateTopSafeArea: (topSafeArea: State["topSafeArea"]) => void
  updateBottomSafeArea: (bottomSafeArea: State["bottomSafeArea"]) => void
  setPairsPosition: (index: number, value: DOMRect) => void
  setNavbarReference: (ref: RefObject<HTMLDivElement>) => void
}

export const useDimension = create<State & Actions>((set) => ({
  dimension: {} as DimensionProps,
  isRedirected: false,
  isDark: false,
  topSafeArea: 0,
  bottomSafeArea: 0,
  pairsPosition: [],
  navbarReference: undefined,
  setIsRedirected: (isRedirected) => set(() => ({ isRedirected })),
  updateDimension: (dimension) => set(() => ({ dimension })),
  updateIsDark: (isDark) => set(() => ({ isDark })),
  updateTopSafeArea: (topSafeArea) => set(() => ({ topSafeArea })),
  updateBottomSafeArea: (bottomSafeArea) => set(() => ({ bottomSafeArea })),
  setPairsPosition: (index, value) =>
    set((state) => {
      const updatedPairs = [...state.pairsPosition]
      if (updatedPairs[index]?.toJSON?.() === value?.toJSON?.()) return state

      updatedPairs[index] = value
      return { pairsPosition: updatedPairs }
    }),
  setNavbarReference: (navbarReference) => set(() => ({ navbarReference })),
}))
